import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup } from "react-leaflet";

import DefaultIcon from "@/components/Map/Icons/DefaultIcon";
import MapTileLayers from "@/components/Map/MapTileLayers";
import type { MapBlockPayload } from "@/features/assistant/types";

export function BlockMap({ payload }: { payload: MapBlockPayload }) {
  const points = payload.points.filter(
    (p) => Number.isFinite(p.lat) && Number.isFinite(p.lng),
  );
  if (points.length === 0) return null;

  const bounds = L.latLngBounds(
    points.map((p) => [p.lat, p.lng] as [number, number]),
  );

  return (
    <div
      className="h-72 w-full overflow-hidden rounded-md border"
      data-testid="assistant-block-map"
    >
      <MapContainer
        bounds={bounds.pad(0.2)}
        boundsOptions={{ maxZoom: 15 }}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <MapTileLayers />
        {points.map((p, i) => (
          <Marker key={i} position={[p.lat, p.lng]} icon={DefaultIcon()}>
            <Popup>
              <strong>{p.label}</strong>
              {p.subtitle && <div className="text-xs">{p.subtitle}</div>}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
